"use strict";

exports.__esModule = true;
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});